import { render, staticRenderFns } from "./LearnerProfileLink.vue?vue&type=template&id=67ea6fe2&"
import script from "./LearnerProfileLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./LearnerProfileLink.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports